export class DropdownListItem {
    public Name:string;
    public Value:string;
    constructor(name:string,value:string){
this.Name = name;
this.Value = value;

    }
}
